import { Children, type FC } from "react";

import { Column } from "@/ui/components/layout/Column";
import { Grid } from "@/ui/components/layout/Grid";
import { STACK_DEFAULTS, type TStackProps } from "@/ui/components/layout/Stack";

export const Stack: FC<TStackProps> = ({
  children,
  "data-component": component = STACK_DEFAULTS["data-component"],
  ...props
}) => (
  <Grid {...props} data-component={component}>
    { Children.map(children, (child) => (
      <Column>{ child }</Column>
    )) }
  </Grid>
);

Stack.displayName = "Stack";
